import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/button";

type AdminDeleteFormProps = {
  action: string;
  csrfToken: string;
  confirmMessage: string;
  organizationDestroyConfirmMessage?: string;
  label?: string;
};

export const AdminDeleteForm: React.FC<AdminDeleteFormProps> = ({
  action,
  csrfToken,
  confirmMessage,
  organizationDestroyConfirmMessage,
  label = "Delete",
}) => (
  <form
    action={action}
    method="post"
    className="inline"
    onSubmit={(e) => {
      if (!window.confirm(confirmMessage)) {
        e.preventDefault();
        return;
      }

      if (organizationDestroyConfirmMessage) {
        if (!window.confirm(organizationDestroyConfirmMessage)) {
          e.preventDefault();
          return;
        }

        const destroyField = e.currentTarget.elements.namedItem(
          "destroy_organizations",
        );
        if (destroyField instanceof HTMLInputElement) {
          destroyField.value = "1";
        }
      }
    }}
  >
    <AuthenticityTokenField csrfToken={csrfToken} />
    <input type="hidden" name="_method" value="delete" />
    <input type="hidden" name="destroy_organizations" value="" />
    <Button type="submit" variant="destructive" size="sm">
      {label}
    </Button>
  </form>
);
